



































import { Vue, Component, Prop } from 'vue-property-decorator'
import MainTitle from '../_components/MainTitle.vue'
import ItemTable from '../_components/ItemTable.vue'
import TagTitle from '../_components/TagTitle.vue'
  @Component({
    components: {
      MainTitle,
      ItemTable,
      TagTitle
    }
  })
export default class extends Vue {
    @Prop({ required: true }) private title!: string
    @Prop({}) private tag!: string
    @Prop({ required: true }) private data!: any
    private list: Array < object > = [];
    private list1: Array < object > = [];
    private list2: Array < object > = [];
    private tableHeader: any = ['性别', '最高分', '最低分', '标准差', '平均分']
    created() {
      if (this.data.array) {
        this.list = this.data.array.map((item:any) => {
          let obj = {
            leftTitle: item.ChangeInChildEnergyZoneTypeIntro,
            children: []
          }
          item.mathVoList && item.mathVoList.forEach((_item:any) => {
            let o = {
              parName: _item.AgeRangeTypeIntro,
              name1: _item.maxScore,
              name2: _item.minScore,
              name3: _item.standardDeviation,
              name4: _item.mean
            }
            obj.children.push(o)
          })
          return obj
        })
      }
      this.list1 = this.list.slice(0, 6)
      this.list2 = this.list.slice(6, 9)
    }
}
